import React from 'react'

import '../../assets/style/ui/header.css'

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <img src="/images/cine-yelmo.png" alt="Yelmo" className="header-logo" />
      </div>
    </header>
  )
}

export default Header
